import React from 'react';
import PropTypes from 'prop-types';

import { currencyCode } from 'Helpers/Geo/data';
import SpecialFormattedNumber from 'Containers/Utility/Price/SpecialFormattedNumber';

function Saving({
  tag: Tag,
  price,
  discount,
  type,
  bundlesTiered,
  fullPrice,
  showMinus,
  discountPercentOverride,
  giveaway,
  ...attributes
}) {
  if (bundlesTiered) return false;
  if (!currencyCode) return false;
  const pence = price[currencyCode];
  const fullPence = fullPrice[currencyCode];

  let saving = discount;
  if (type === 'bundle' && fullPence) saving = (fullPence - pence) / fullPence;
  if (saving <= 0 && discountPercentOverride === 0) return false;

  let savingPrice = Math.min(0.99, saving);
  if (giveaway) savingPrice = saving;

  return (
    <Tag {...attributes}>
      {/* eslint-disable react/style-prop-object */}
      {showMinus &&
        <span>-</span>
      }
      {discountPercentOverride > 0 ?
        <SpecialFormattedNumber value={(discountPercentOverride / 100)} style="percent" />
        :
        <SpecialFormattedNumber value={savingPrice} style="percent" />
      }
      {/* eslint-enable react/style-prop-object */}
    </Tag>
  );
}

const priceProp = {
  GBP: PropTypes.number,
  EUR: PropTypes.number,
  USD: PropTypes.number,
  CAD: PropTypes.number,
  AUD: PropTypes.number,
  RUB: PropTypes.number,
  JPY: PropTypes.number,
};

Saving.propTypes = {
  price: PropTypes.shape(priceProp),
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  discount: PropTypes.number,
  type: PropTypes.oneOf([
    'game',
    'bundle',
    'dlc',
  ]),
  fullPrice: PropTypes.shape(priceProp),
  bundlesTiered: PropTypes.bool,
  showMinus: PropTypes.bool,
  discountPercentOverride: PropTypes.number,
  giveaway: PropTypes.bool,
};

Saving.defaultProps = {
  price: {},
  tag: 'span',
  discount: 0,
  type: 'game',
  fullPrice: {},
  bundlesTiered: false,
  showMinus: true,
  discountPercentOverride: 0,
  giveaway: false,
};

export default Saving;
